import API from "../Network/API";
import {ACTION_TYPES} from "../Network/postActionTypes";
import React, {useEffect, useReducer, useState} from "react";
import {INITIAL_STATE, NotificationReducer} from "../Reducer/NotificationReducer";
import NotificationList from "../Props/NotificationList";
import ContentLoader from "react-content-loader"

export default function Notification() {
    const [page, setPage] = useState(1);
    const [state, dispatch] = useReducer(NotificationReducer, INITIAL_STATE);
    const [progress, setProgress] = useState(false);
    useEffect(() => {

        dispatch({type: ACTION_TYPES.FETCH_START});
        API.get(`/notifications-all`).then(response => {
            dispatch({type: ACTION_TYPES.FETCH_SUCCESS, payload: response.data.data});
            if (response.data.data.notification.length>0) {
                setPage((page+1))
            }
        }).catch((error) => {
            dispatch({type: ACTION_TYPES.FETCH_ERROR});
        });



    }, []);

    function fetchNext() {
        setProgress(true)
        API.get(`/notifications-all?page=${page}`).then(response => {
            dispatch({type: ACTION_TYPES.FETCH_SUCCESS_LOAD, payload: response.data.data});
            if (response.data.data.notification.length>0) {
                setPage((page+1))
            }
            setProgress(false)
        }).catch((error) => {
            dispatch({type: ACTION_TYPES.FETCH_ERROR});
            setProgress(false)
        });

    }
    return (
        <div className="min-vh-100 bg-white">
            <div className="container py-4">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-xl-7">
                        {/* Header */}
                        <div className="d-flex align-items-center justify-content-between mb-4 pb-3 border-bottom">
                            <h1 className="h2 fw-bold text-dark mb-0">Notifications</h1>
                            <button className="btn btn-outline-dark rounded-pill px-4 py-2 border-2" type="button">
                                <i className="fa-solid fa-check me-2"></i>
                                Mark all read
                            </button>
                        </div>

                        {/* Notifications Container */}
                        <div className="bg-white">
                            {/* Loading State */}
                            {state.loading && (
                                <div className="notification-skeleton">
                                    {[{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}].map((post, i) => (
                                        <div key={i} className="d-flex align-items-start py-4 border-bottom">
                                            <ContentLoader
                                                speed={2}
                                                width="100%"
                                                height={70}
                                                viewBox="0 0 400 70"
                                                backgroundColor="#f8f9fa"
                                                foregroundColor="#e9ecef"
                                            >
                                                <circle cx="35" cy="35" r="25" />
                                                <rect x="80" y="20" rx="4" ry="4" width="250" height="14" />
                                                <rect x="80" y="42" rx="4" ry="4" width="180" height="11" />
                                                <rect x="80" y="58" rx="4" ry="4" width="120" height="9" />
                                            </ContentLoader>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* Notifications List */}
                            {!state.loading && (
                                <div className="notifications-wrapper">
                                    <NotificationList notification={state.notification_data}/>
                                </div>
                            )}

                            {/* Load More Section */}
                            {state.data.next_page_url != null && !state.loading && (
                                <div className="text-center py-4 border-top mt-4">
                                    <button 
                                        onClick={() => fetchNext()} 
                                        className="btn btn-outline-dark rounded-pill px-5 py-3 border-2"
                                        disabled={progress}
                                    >
                                        {progress ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Loading...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa-solid fa-plus me-2"></i>
                                                Load more notifications
                                            </>
                                        )}
                                    </button>
                                </div>
                            )}

                            {/* Empty State */}
                            {!state.loading && state.notification_data && state.notification_data.length === 0 && (
                                <div className="text-center py-5 my-5">
                                    <div className="mb-4">
                                        <i className="fa-solid fa-bell-slash text-dark opacity-25" style={{fontSize: '4rem'}}></i>
                                    </div>
                                    <h3 className="h5 fw-bold text-dark mb-2">No notifications yet</h3>
                                    <p className="text-muted mb-0 lead">You'll see your notifications here when you have new activity.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}